import { render, staticRenderFns } from "./RecentEventsSection.vue?vue&type=template&id=18c43d16&"
import script from "./RecentEventsSection.vue?vue&type=script&lang=js&"
export * from "./RecentEventsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports